
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getLModelFileAdd, getLModelFileDetail } from "@/api/api-basic";
import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {
    uploadImage,
    showImg
  }
})
export default class PiAddSystemNotice extends Vue {
  private formInline: objAny = {
    attachmentPkId: "",
    businessType: "",
    fileName: "",
    fileType: "",
    remark: "",
    templatePkId: "",
    lang: ""
  };
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("modelFile.add");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    attachmentPkId: [
      {
        required: true,
        message: i18n.t("modelFile.attachmentPkIdPl"),
        trigger: "blur"
      }
    ],
    businessType: [
      {
        required: true,
        message: i18n.t("modelFile.businessTypePl"),
        trigger: "blur"
      }
    ],
    fileName: [
      {
        required: true,
        message: i18n.t("modelFile.fileNamePl"),
        trigger: "blur"
      }
    ],
    fileType: [
      {
        required: true,
        message: i18n.t("modelFile.fileTypePl"),
        trigger: "blur"
      }
    ],
    lang: [
      {
        required: true,
        message: i18n.t("modelFile.langPl"),
        trigger: "blur"
      }
    ],
    remark: [
      {
        required: true,
        message: i18n.t("modelFile.remarkPl"),
        trigger: "blur"
      }
    ]
    // templatePkId: [
    //   { required: true, message: "请输入文件模板主键", trigger: "blur" }
    // ]
  };
  private isAdd = false;
  private PkId = "";

  private langList: object[] = [];
  private fileTypeObjList: object[] = [];
  private businessTypeObjList: object[] = [];
  public open(item?: objAny) {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;
    if (!item) {
      this.isAdd = true;
      this.formInline.attachmentPkId = "";
      this.formInline.businessType = "";
      this.formInline.fileName = "";
      this.formInline.fileType = "";
      this.formInline.remark = "";
      this.formInline.templatePkId = "";
      this.modalTitle = i18n.t("modelFile.add");
    } else {
      this.isAdd = false;
      this.PkId = item.pkid;
      console.log(item.pkid);

      this.modalTitle = i18n.t("modelFile.updata");
      this.getLModelFileDetail();
    }
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    const ret = await getLModelFileAdd(json);
    if (ret.status === this.$config.apiStatus) {
      if (this.isAdd) {
        this.$Message.success(i18n.t("modelFile.addSuccess"));
      } else {
        this.$Message.success(i18n.t("modelFile.updateSuccess"));
      }
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  async getLModelFileDetail(): Promise<void> {
    this.loading = true;
    const ret = await getLModelFileDetail({ PkId: this.PkId });
    if (ret.status === this.$config.apiStatus) {
      this.formInline.attachmentPkId = ret.data[0].attachmentPkId;
      this.formInline.businessType = ret.data[0].businessType + "";
      this.formInline.fileName = ret.data[0].fileName;
      this.formInline.fileType = ret.data[0].fileType + "";
      this.formInline.remark = ret.data[0].remark;
      this.formInline.templatePkId = ret.data[0].pkid;
      this.formInline.lang = ret.data[0].lang + "";
    }
    this.loading = false;
  }
  public uploadImg(data: objAny): void {
    console.log(data);
    this.formInline.attachmentPkId = data.attachmentRecordPkId;
    this.formInline.fileName = data.fileName;
    // this.formInline.attachmentPkId = data.attachmentRecordPkId;
  }
  async getOptionList() {
    const ret = await getOptionList([
      optionKey.fileTypeObj,
      optionKey.businessTypeObj,
      optionKey.langObj
    ]); //请求字典
    this.fileTypeObjList = ret[optionKey.fileTypeObj]; //模板文件类型
    this.businessTypeObjList = ret[optionKey.businessTypeObj]; //模板文件业务类型
    this.langList = ret[optionKey.langObj];
  }
  mounted() {
    //     fileTypeObj: "12427", //模板文件类型
    // businessTypeObj: "12428" //模板文件业务类型
    this.getOptionList();
  }
}
